import { render, staticRenderFns } from "./developerConfig.vue?vue&type=template&id=1471801d&scoped=true"
import script from "./developerConfig.vue?vue&type=script&lang=js"
export * from "./developerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1471801d",
  null
  
)

export default component.exports